export class RollbarError extends Error {
  constructor(message: string, public readonly logging = true) {
    super(message);
    this.name = ROLLBAR_ERROR_NAME;
  }
}

export const ROLLBAR_ERROR_NAME = 'RollbarError';
